/* math utils */

const clamp = (v, min, max) => (v < min ? min : (v > max ? max : v));
const lerp = (t, x0, x1) => (x0 + (x1 - x0) * t);
const lerpn = (i, n, x0, x1) => lerp(i/n, x0, x1);
const unlerp = (v, x0, x1) => (v - x0) / (x1-x0);
const rescale = (v, f0, f1, t0, t1) => (t0 + ((v - f0) / (f1-f0)) * (t1 - t0));
const ease = (x) => (3*x*x - 2*x*x*x);
const easen = (n, x) => {
	for (var i = 0; i < n; i++) x = ease(x);
	return x;
};

const cubic_bezier = (t, p0, p1, p2, p3) => {
	const t1 = 1.0 - t;
	const t1s = t1*t1;
	const t1c = t1*t1*t1;
	const ts = t*t;
	const tc = t*t*t;
	return (p0 * t1c) + (p1 * t * 3.0 * t1s) + (p2 * ts * 3.0 * t1) + (p3 * tc);
}

const deg2rad = (deg) => deg/180*Math.PI;
const rad2deg = (rad) => rad/Math.PI*180;

/* 2d vector math (vectors are arrays with size=2) */
const v2_dot = (a, b) => a[0]*b[0] + a[1]*b[1];
const v2_length = (v) => Math.sqrt(v2_dot(v, v));
const v2_add = (a, b) => [a[0]+b[0], a[1]+b[1]];
const v2_sub = (a, b) => [a[0]-b[0], a[1]-b[1]];
const v2_distance = (a, b) => v2_length(v2_sub(b, a));
const v2_scale = (v, scalar) => [v[0]*scalar, v[1]*scalar];
const v2_unit = (v) => v2_scale(v, 1/v2_length(v));

/* screen-space / SVG friendly v2 functions:
 *  - coordinate system:
 *      left to right => X- to X+
 *        up to down  => Y- to Y+
 *  - zero angle is [1,0]; a horizontal right-pointing vector
 *  - ascending angles are clockwise, descending angles are counter clockwise
 */
const v2_radians = (radians) => [Math.cos(radians), Math.sin(radians)];
const v2_degrees = (degrees) => v2_radians(deg2rad(degrees));

/* 90 degrees clockwise / counter-clockwise rotation */
const v2_rot90cw = (v) => [-v[1], v[0]];
const v2_rot90ccw = (v) => [v[1], -v[0]];

const floor_to_decimals = (value, n_decimals) => {
	const pow = Math.pow(10, n_decimals);
	return Math.floor(value * pow) / pow;
};

const ceil_to_decimals = (value, n_decimals) => {
	const pow = Math.pow(10, n_decimals);
	return Math.ceil(value * pow) / pow;
};

const v_pairwise_op = (op,a,b) => {
	const N = a.length;
	if (N !== b.length) throw new Error("not vectors of same length: " + JSON.stringify(a) + " vs " + JSON.stringify(b));
	var result = [];
	for (var i = 0; i < N; i++) result.push(op(a[i],b[i]));
	return result;
};

const v_add = (a,b) => {
	return v_pairwise_op((x,y) => x+y, a, b);
};

const v_scale = (v, scalar) => {
	return v.map(x => x*scalar);
};

const parse_hex = (hex) => parseInt(hex, 16);

const hex2col = (hex) => {
	var start = 0;
	if (hex[0] === "#") start = 1;
	const digits_per_component = {3:1, 4:1, 6:2, 8:2}[hex.length - start];
	if (digits_per_component === undefined) throw new Error("invalid color hex string length: " + hex)
	var col = [];
	var i;
	if (digits_per_component === 1) {
		for (i = start; i < hex.length; i++) {
			const hex_digit = parse_hex(hex[i]);
			col.push(((hex_digit << 4) + hex_digit) / 0xff);
		}
	} else if (digits_per_component === 2) {
		for (i = start; i < hex.length; i += 2) {
			col.push(parse_hex(hex.slice(i, i+2)) / 0xff);
		}
	} else {
		throw new Error("ASSERTION ERROR: unhandled digits_per_component value of " + digits_per_component);
	}
	return col;
};

const col2hex = (col) => {
	const N = col.length;
	if (N !== 3 && N !== 4) throw new Error("not a color: " + col);
	var hex = "#";
	for (var i = 0; i < N; i++) {
		hex += clamp(Math.round(col[i] * 255), 0, 255).toString(16).padStart(2, "0");
	}
	return hex;
};

const val2col = (v) => {
	return typeof v === "string" ? hex2col(v) : v;
};

const val2hex = (v) => {
	return typeof v === "object" ? col2hex(v) : v;
}

const col_lighten = (col, amount, light_col) => {
	if (light_col === undefined) light_col = [1,1,1];
	light_col = v_scale(light_col, amount);
	return [...v_add(col.slice(0, 3), light_col), ...col.slice(3)];
}

export default {
	clamp,
	lerp,
	lerpn,
	unlerp,
	rescale,
	ease,
	easen,
	cubic_bezier,

	deg2rad,
	rad2deg,

	v2_dot,
	v2_length,
	v2_add,
	v2_sub,
	v2_distance,
	v2_scale,
	v2_unit,

	v2_radians,
	v2_degrees,

	v2_rot90cw,
	v2_rot90ccw,

	floor_to_decimals,
	ceil_to_decimals,

	v_pairwise_op,
	v_add,
	v_scale,

	hex2col,
	col2hex,
	val2col,
	val2hex,
	col_lighten,
};



// WEBPACK FOOTER //
// ./src/MUTIL.js